import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import MFManageForecastMainContent from "./MFManageForecastMainContent";
import { MFBottlerSelectionProvider } from "../../../context/MFBottlerSelectionContext";
import { MFCustomBottlerSelectionProvider } from "../../../context/MFCustomBottlerSelectionContext";
import { setActiveDataElement } from "../../../redux/userSlice";

const MFManageForecast = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Market Forecast"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/bmf-manage-forecast" },
                { title: "Manage Forecast" },
              ]}
              title="Manage Market Forecast File"
            />
            <div className="container">
              <MFBottlerSelectionProvider>
                <MFCustomBottlerSelectionProvider>
                  <MFManageForecastMainContent></MFManageForecastMainContent>
                </MFCustomBottlerSelectionProvider>
              </MFBottlerSelectionProvider>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default MFManageForecast;
